import type { DroptreeValue, TextField } from '@sitecore/types/NewsletterFormIntegratedWithRevolution';

type ConfiguredFieldValue = TextField | DroptreeValue;

export function getConfiguredFieldValue(field: ConfiguredFieldValue): string {
  if ((field as DroptreeValue).fields?.data?.value) {
    return (field as DroptreeValue).fields.data.value.value;
  }

  return (field as TextField).value ?? '';
}
